exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.lgPQq{cursor:pointer}span._28XBw,span.lgPQq{font-size:16px;margin:0 8px}.UNbbR{background:#f3d8d8}._1ZUBm{padding:0!important}._3hIzq{padding:7px 3px}.Ir1xO div{overflow-x:hidden!important}.Ir1xO div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "lgPQq",
	"info": "_28XBw",
	"sinAcceso": "UNbbR",
	"tdClear": "_1ZUBm",
	"field": "_3hIzq",
	"hidden": "Ir1xO"
};